<template>
  <div class="ui-pannel">
    <p class="title">{{$t('user.myTimetable')}}</p>
    <div class="content">
      <div class="wrap">
        <!-- <div class="course">
          <span class="name">Course:English Literature</span>
          <span class="tutor">tutor：Amanda</span>
          <span class="time">19:00~20:00</span>
        </div> -->
        <div class="topic-box">
          <a class="pre" @click="changeDate(1)">{{ $t("weeks.pre") }}</a>
          <p class="topic">{{ $t("weeks.title") }}</p>
          <a class="next" @click="changeDate">{{ $t("weeks.next") }}</a>
        </div>
        <ul class="dates">
          <li v-for="item in dateArr" :key="item.week">
            <p class="week">{{ item.week }}</p>
            <p class="date">{{ item.show }}</p>
          </li>
        </ul>
        <ul class="times">
          <li v-for="i in 7" :key="i">
            <p
              v-for="(cell, index) in timeArr[i - 1]"
              :key="index"
              @click="order(i - 1, index, timeArr[i - 1])"
              :class="{ disable: cell.state === 1, fulled: cell.state === 2 }"
            >
              {{ cell.time }}
            </p>
            <!-- {{booked.i}} -->
            <div
              class="booked"
              v-if="booked.i == i && booked.date === dateArr[i - 1].date"
              :style="{ top: booked.num * 30 + 20 + 'px' }"
            >
              <!-- <span class="txt">原始预约时段</span> -->
            </div>
            <div
              class="order"
              v-if="newOrder.x == i && newOrder.date === dateArr[i - 1].date"
              :style="{ top: newOrder.num * 30 + 20 + 'px' }"
            >
              <!-- <span class="txt">预约</span> -->
            </div>
            <div
              class="full"
              v-for="(n, index) in full[i - 1]"
              :style="{ top: n * 30 + 20 + 'px' }"
              :key="index"
            >
              <!-- <span class="txt">已满</span> -->
            </div>
          </li>
        </ul>
        <div class="foot">
          <a class="ui-btn" @click="submit">{{ $t("common.submit") }}</a>
          <a class="ui-btn gray" @click="$router.go(-1)">{{ $t("common.back") }}</a>
        </div>
      </div>
    </div>
    <comfirm
      @submit="comfirmNext"
      @cancel="comfirmInfo.show = false"
      :info="comfirmInfo"
    />
  </div>
</template>
<i18n>
{
  "cn": {
    "rebook":{
      "saveSuccess":"改签申请成功，请等侯老师确认"
    }
  },
  "TW": {
    "rebook":{
      "saveSuccess":"改簽申請成功，請等侯老師確認"
    }
  },
  "en": {
    "rebook":{
      "saveSuccess":"Please wait for the teacher's confirmation"
    }
  }
}
</i18n>
<script>
import { changeApply } from "@/service/api.js";
import {
  getBaseProfile,
  getTeacherAppointedTimeList,
  getScheduleListByTeacherId,
} from "@/service/teacherApi.js";
import { getStudentStudyCourseList } from "@/service/studentApi.js";
import getTimeArr from "@/data.js";
import moment from "moment";
import comfirm from "@/components/Comfirm.vue";
export default {
  components: { comfirm },
  data() {
    return {
      timeArr: [],
      newOrder: { x: 0, date: 0, num: 0 },
      booked: { x: 0, date: 0, num: 0 },
      full: [[], [], [], [], [], [], []],
      currentDay: "",
      dateArr: [
        { date: '', show: '', week: this.$t("weeks.mon") },
        { date: '', show: '', week: this.$t("weeks.tues") },
        { date: '', show: '', week: this.$t("weeks.wed") },
        { date: '', show: '', week: this.$t("weeks.thur") },
        { date: '', show: '', week: this.$t("weeks.fri") },
        { date: '', show: '', week: this.$t("weeks.sat") },
        { date: '', show: '', week: this.$t("weeks.sun") }
      ],
      comfirmInfo: {
        show: false,
        title: "提示",
        topic: "您将改签1节课程",
        desc: "老师审核通过后改签才能生效",
        cancel: "取消",
        comfirm: "提交",
      },
    };
  },
  methods: {
    order(x, y, row) {
      if (row[y].state === 0 && y < row.length - 4) {
        let state = true;
        for (let j = 1; j < 5; j++) {
          if (row[y + j].state !== 0) {
            state = false;
          }
        }
        if (state) {
          this.newOrder.x = x + 1;
          this.newOrder.date = this.dateArr[x].date;
          this.newOrder.num = y;
          this.$forceUpdate();
        }
      }
    },
    resetDate() {
      let day = moment(this.currentDay).format("d");
      if (day == 0) {
        day = 7;
      }
      for (let i = 0; i < 7; i++) {
        this.dateArr[i].date = moment(this.currentDay)
          .subtract(day - i - 1, "day")
          .format("YYYY-MM-DD");
        if (
          moment(this.dateArr[i].date).format("YYYYMMDD") ===
          moment().format("YYYYMMDD")
        ) {
          this.dateArr[i].show = "今天";
        } else {
          this.dateArr[i].show = moment(this.dateArr[i].date).format("MM-DD");
        }
      }
      this.showOrderList();
    },
    changeDate(type) {
      if (type === 1) {
        this.currentDay = moment(this.currentDay)
          .subtract(7, "day")
          .format("YYYYMMDD");
      } else {
        this.currentDay = moment(this.currentDay)
          .add(7, "day")
          .format("YYYYMMDD");
      }
      this.resetDate();
      // this.getStudentStudyCourseList()
      this.$forceUpdate();
    },
    async showOrderList() {
      this.timeArr = getTimeArr(1);
      this.booked = {};
      this.full = [[], [], [], [], [], [], []];
      const beginTime = moment(this.dateArr[0].date).format("X");
      const endTime = moment(this.dateArr[6].date).endOf("date").format("X");
      this.getScheduleListByTeacherId(beginTime, endTime);
      const res = await getTeacherAppointedTimeList({
        teacherId: this.$route.query.id,
        beginTime: beginTime,
        endTime: endTime,
      });
      const res2 = await getStudentStudyCourseList({
        beginTime: beginTime,
        endTime: endTime,
      });
      if (res2.data.status === 1 && res.data.status === 1) {
        this.setDisable(res2.data.data.concat(res.data.data));
      }
    },
    async getScheduleListByTeacherId(beginTime, endTime) {
      const res = await getScheduleListByTeacherId({
        teacherId: this.$route.query.id,
        timeIntervalBegin: beginTime,
        timeIntervalEnd: endTime,
      });
      if (res.data.status === 1) {
        if (res.data.data.length) {
          for (let i = 0; i < res.data.data.length; i++) {
            let arr = res.data.data[i].entries;
            for (let j = 0; j < arr.length; j++) {
              if (arr[j].scheduleEntryType === 1) {
                let arr2 = arr[j].weekDays.split(",");
                let start = arr[j].timeBegin / 900;
                let end = arr[j].timeEnd / 900;
                for (let k = 0; k < arr2.length; k++) {
                  let x = arr2[k] - 1;
                  for (let l = start; l <= end; l++) {
                    if (moment().isBefore(this.dateArr[x].date)) {
                      this.timeArr[x][l].state = 0;
                    }
                  }
                }
              }
            }
          }
          for (let i = 0; i < res.data.data.length; i++) {
            let arr = res.data.data[i].entries;
            for (let j = 0; j < arr.length; j++) {
              if (arr[j].scheduleEntryType === 2) {
                let x = -1;
                for (let k = 0; k < 7; k++) {
                  if (
                    moment(this.dateArr[k].date).isSame(
                      arr[j].scheduleDate * 1000,
                      "day"
                    )
                  ) {
                    x = k;
                    break;
                  }
                }
                if (x !== -1) {
                  let start = arr[j].timeBegin / 900;
                  let end = arr[j].timeEnd / 900;
                  for (let l = start; l <= end; l++) {
                    this.timeArr[x][l].state = 1;
                  }
                }
              }
            }
          }
        }
      }
    },
    setDisable(data) {
      const res = new Map();
      data = data.filter((data) => !res.has(data.id) && res.set(data.id, 1));
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < 7; j++) {
          if (
            moment(data[i].beginTime * 1000).format("YYYYMMDD") ==
            moment(this.dateArr[j].date).format("YYYYMMDD")
          ) {
            let n =
              (moment(data[i].beginTime * 1000).format("X") -
                moment(this.dateArr[j].date).format("X")) /
              900;
            if (data[i].beginTime == this.$route.query.time) {
              this.booked.date = moment(this.currentDay).format("YYYY-MM-DD");
              this.booked.i = moment(this.currentDay).format("d");
              if (this.booked.i == 0) {
                this.booked.i = 7;
              }
              this.booked.num =
                moment(this.$route.query.time * 1000).format("H") * 4 +
                moment(this.$route.query.time * 1000).format("m") / 15;
              this.$forceUpdate();
            } else {
              this.full[j].push(n);
            }
          }
        }
      }
      let arr = this.full; // 设置不可预约字段
      for (let i = 0; i < 7; i++) {
        if (arr[i].length) {
          for (let j = 0; j < arr[i].length; j++) {
            let n = arr[i][j];
            let y = i;
            for (let x = 0; x < 5; x++) {
              if (!!this.timeArr[y][n + x]) {
                this.timeArr[y][n + x].state = 2;
              }
            }
          }
        }
      }
    },
    reset() {
      this.newOrder = { x: 0, date: "", num: 0 };
    },
    async comfirmNext() {
      let obj = { orderCourseId: this.$route.query.orderCourseId };
      let time =
        this.newOrder.date +
        " " +
        parseInt(this.newOrder.num / 4) +
        ":" +
        (this.newOrder.num % 4) * 15 +
        ":00";
      obj.applyBeginTime = moment(time).format("X");
      obj.applyEndTime = moment(time).add(1, "hour").format("X");
      // console.log(moment(obj.applyBeginTime * 1000).format("YYYY-MM-DD HH:mm:ss"))
      const res = await changeApply(obj);
      if (res.data.status === 1) {
        this.$message({
          type: "success",
          message: this.$t('rebook.saveSuccess'),
        });
        this.$router.push({ path: "/user/timetable" });
      }
    },
    submit() {
      if (this.newOrder.date) {
        this.comfirmInfo.show = true;
      } else {
        this.$message({ type: "warning", message: "请选择要改签的时间段" });
      }
    },
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER);
    },
  },
  created() {
    this.currentDay = moment(this.$route.query.time * 1000).format(
      "YYYY-MM-DD"
    );
    this.timeArr = getTimeArr(1);
    this.resetDate();
    // for(let i = 0; i < 14; i ++){
    //   if(arr[i].length){
    //     for(let j = 0; j < arr[i].length; j ++){
    //       let n = arr[i][j]
    //       let y = i
    //       if(i >= 7){
    //         y = i - 7
    //       }
    //       for(let x = 0; x < 5; x ++){
    //         this.timeArr[y][n + x].state = 2
    //       }
    //     }
    //   }
    // }
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 0 50px 100px;
}
.inviter {
  height: 50px;
  background: rgba(0, 33, 71, 0.1);
  padding-left: 64px;
  line-height: 50px;
  font-size: 16px;
  color: #333;
}
.wrap {
  margin-top: 40px;
  box-shadow: 0 6px 12px rgba($color: #000000, $alpha: 0.05);
  border-radius: 0 0 12px 12px;
}
.course {
  height: 50px;
  background: rgba(0, 33, 71, 0.1);
  font-size: 16px;
  color: #333;
  display: flex;
  padding: 0 50px;
  align-items: center;
  .name {
    min-width: 260px;
    padding-right: 20px;
  }
  .tutor {
    flex: 1;
  }
  // .btn-enter{display: inline-block; padding: 0 12px; height: 30px; border-radius: 5px; background: #002147; line-height: 30px; color: #fff; font-size: 14px;}
}
.topic-box {
  height: 100px;
  border-bottom: 1px solid #d6d6d6;
  display: flex;
  align-items: center;
  padding: 0 50px;
  .topic {
    font-size: 18px;
    line-height: 42px;
    text-align: center;
    flex: 1;
    font-weight: bold;
  }
}
.pre,
.next {
  height: 42px;
  font-size: 16px;
  color: #666;
  line-height: 42px;
  &:hover {
    opacity: 0.7;
  }
  &:active {
    opacity: 0.9;
  }
}
.pre {
  float: left;
  padding-left: 49px;
  background: url(../assets/arrow_left.png) no-repeat left center;
}
.next {
  float: right;
  padding-right: 49px;
  background: url(../assets/arrow_right.png) no-repeat right center;
}
.dates {
  overflow: hidden;
  border-bottom: 1px solid #d6d6d6;
  padding: 40px 37px 20px;
  li {
    float: left;
    margin: 0 4px;
    width: 100px;
    text-align: center;
    font-size: 16px;
  }
  .date {
    color: #666;
    margin-top: 5px;
  }
}
.times {
  overflow: hidden;
  border-bottom: 1px solid #d6d6d6;
  padding: 0 37px;
  li {
    width: 100px;
    margin: 0 4px;
    padding: 20px 0;
    float: left;
    text-align: center;
    color: #666;
    line-height: 30px;
    position: relative;
  }
  li:nth-child(2n + 1) {
    background: #ebebeb;
  }
  li:nth-child(2n) {
    background: #8a8a8a;
  }
  p {
    position: relative;
    z-index: 1;
    cursor: pointer;
    transition: color 0.3s;
    height: 30px;
    &:hover {
      color: #000;
    }
    &.disable {
      cursor: no-drop;
      color: #cecdcd;
    }
    &.fulled {
      cursor: no-drop;
      color: #666;
    }
  }
}
.booked,
.full,
.order {
  position: absolute;
  left: 0;
  top: 20px;
  right: 0;
  height: 150px;
  border-radius: 20px;
  border: 1px solid #002314;
  padding-left: 78px;
  text-align: left;
  .txt {
    display: inline-block;
    width: 18px;
    font-weight: bold;
    line-height: 19px;
    vertical-align: middle;
    color: #000;
  }
  &:after {
    content: "";
    height: 100%;
    display: inline-block;
    vertical-align: middle;
  }
}
.booked {
  background: #9dada2;
}
.full {
  background: #cacaca;
}
.order {
  background: #4e9cda;
}
.foot {
  padding: 65px 0 80px;
  text-align: center;
  .ui-btn {
    margin: 0 15px;
  }
}
</style>